// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2-tTu","choiceBoxes":"toolbarselects_choiceBoxes__1quPj","simpleField":"toolbarselects_simpleField__2sgLN"};